import { KeyboardArrowLeft } from '@mui/icons-material';
import { Box, Button, ButtonProps, Typography } from '@mui/material';
import type { FC, PropsWithChildren, ReactNode } from 'react';

export type PageTitleButton = ButtonProps & {
  label?: string;
};

export type PageTitleProps = {
  backButton?: Omit<PageTitleButton, 'label' | 'startIcon' | 'endIcon'>;
  actionButton?: PageTitleButton | PageTitleButton[];
} & ({ title: ReactNode; titleComponent?: ReactNode } | { title?: ReactNode; titleComponent: ReactNode });

export const PageTitle: FC<PropsWithChildren<PageTitleProps>> = ({
  title,
  titleComponent,
  backButton,
  actionButton = [],
  children,
}) => {
  const actions: PageTitleButton[] = Array.isArray(actionButton) ? actionButton : [actionButton];
  return (
    <Box display="flex" alignItems="center">
      {backButton && (
        <Button
          variant="outlined"
          color="tertiary"
          sx={({ palette }) => ({
            minWidth: '54px',
            height: '51px',
            padding: 0,
            marginRight: '12px',
            borderColor: palette.primary[30],
          })}
          onClick={backButton?.onClick}
        >
          <KeyboardArrowLeft sx={({ palette }) => ({ color: palette.primary[60], fontSize: '44px' })} />
        </Button>
      )}
      {titleComponent ? (
        titleComponent
      ) : (
        <Typography sx={({ palette }) => ({ color: palette.common.black, flexGrow: 1 })} variant="h2">
          {title}
        </Typography>
      )}

      {actions.map((action, i) => {
        const { label, ...otherProps } = action;
        return (
          <Button
            key={`${label}_${i}`}
            variant="contained"
            color="secondary"
            size="medium"
            sx={{ marginLeft: '20px' }}
            {...otherProps}
          >
            {label}
          </Button>
        );
      })}
      {children}
    </Box>
  );
};
